import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// The node areas' search lives in the URL as ?search= (the key the recycle
// bin's grid uses), so Refresh, Back and a shared link bring it back. Typing
// replaces the entry rather than pushing one per keystroke; other query
// parameters are kept.
export const SEARCH_PARAM = 'search'

export const useSearchParam = () => {
  const location = useLocation()
  const history = useHistory()
  const value = new URLSearchParams(location.search).get(SEARCH_PARAM) || ''

  const setValue = useCallback(
    next => {
      const current = history.location
      const params = new URLSearchParams(current.search)
      if (next) params.set(SEARCH_PARAM, next)
      else params.delete(SEARCH_PARAM)
      const search = params.toString()
      history.replace({ pathname: current.pathname, search: search ? `?${search}` : '', hash: current.hash })
    },
    [history]
  )

  return [value, setValue]
}
